import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import { AuthProvider } from './context/AuthContext/AuthContext.tsx'
import { ConfigurationsProvider } from './context/ConfigurationsContext/ConfigurationsContext.tsx'
import { FirebaseProvider } from './context/FirebaseContext/FirebaseContext.tsx'
import { BrowserRouter } from 'react-router-dom'
const registerServiceWorker = () => {
  if (!('serviceWorker' in navigator)) return
  if (!import.meta.env.PROD) return
  if (import.meta.env.VITE_ENABLE_SW !== 'true') return
  import('virtual:pwa-register').then(({ registerSW }) => {
    registerSW({ immediate: false })
  })
}

window.addEventListener(
  'load',
  () => {
    setTimeout(registerServiceWorker, 4000)
  },
  { once: true },
)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ConfigurationsProvider>
          <FirebaseProvider>
          
              <App />
        
          </FirebaseProvider>
        </ConfigurationsProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
)
